export default function UROLogo({ size = 22 }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="uro-logo-grad" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0" stopColor="#FF7E67"/>
            <stop offset="1" stopColor="#FF4D8D"/>
          </linearGradient>
        </defs>
        <path d="M5 5h6v12a5 5 0 0 0 10 0V5h6v12a11 11 0 1 1-22 0V5Z" fill="url(#uro-logo-grad)"/>
        <circle cx="16" cy="17" r="2.4" fill="#050505"/>
      </svg>
      <span style={{ fontSize: 17, fontWeight: 800, letterSpacing: '-0.04em', color: '#fff' }}>URO</span>
    </div>
  );
}
